import { useQuery } from 'react-query';

import {
  getUserBinders,
  mapUserBindersByMemberId,
  type UserBinderMap
} from '../../services/userBindersService';
import { USER_BINDER_QUERY_KEYS } from '../queryKeys';

type UseGetUserBinderOptions = {
  enabled?: boolean;
};

export function useGetUserBinder(
  currentUserId: string | undefined,
  ownerUserId: string | undefined,
  artistId: string | undefined,
  options: UseGetUserBinderOptions = {}
) {
  const { enabled = true } = options;

  return useQuery<UserBinderMap, Error>(
    USER_BINDER_QUERY_KEYS.covers(currentUserId, ownerUserId, artistId),
    () => {
      if (!artistId) {
        throw new Error('artistId is required');
      }

      return getUserBinders({ artistId }).then(mapUserBindersByMemberId);
    },
    {
      enabled: enabled && !!currentUserId && !!ownerUserId && !!artistId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
